// 公共页路由
export default [
  {
    path: '/publicView/apply/ApkUpdateAddPage',
    name: 'ApkUpdateAddPage',
    component: () => import('@/views/publicView/apply/apkUpdateAddPage.vue'),
    meta: {
      title: '新增APK'
    }
  },
  {
    path: '/publicView/apply/ApkUpdateEditPage',
    name: 'ApkUpdateEditPage',
    component: () => import('@/views/publicView/apply/apkUpdateEditPage.vue'),
    meta: {
      title: '编辑APK'
    }
  },
  {
    path: '/publicView/apply/AppUpdateAddPage',
    name: 'AppUpdateAddPage',
    component: () => import('@/views/publicView/apply/appUpdateAddPage.vue'),
    meta: {
      title: '新增APP'
    }
  },
  {
    path: '/publicView/apply/AppUpdateEditPage',
    name: 'AppUpdateEditPage',
    component: () => import('@/views/publicView/apply/appUpdateEditPage.vue'),
    meta: {
      title: '编辑APP'
    }
  },
  {
    path: '/publicView/apply/otaUpdateAddPage',
    name: 'OtaUpdateAddPage',
    component: () => import('@/views/publicView/apply/otaUpdateAddPage.vue'),
    meta: {
      title: '新增OTA'
    }
  },
  {
    path: '/publicView/apply/otaUpdateEditPage',
    name: 'OtaUpdateEditPage',
    component: () => import('@/views/publicView/apply/otaUpdateEditPage.vue'),
    meta: {
      title: '编辑OTA'
    }
  },
  {
    path: '/publicView/model/addModelPage',
    name: 'AddModelPage',
    component: () => import('@/views/publicView/model/addModelPage.vue'),
    meta: {
      title: '新增机型'
    }
  },
  {
    path: '/publicView/model/editModelPage',
    name: 'EditModelPage',
    component: () => import('@/views/publicView/model/editModelPage.vue'),
    meta: {
      title: '编辑机型'
    }
  },
  {
    path: '/publicView/feedback/feedbackList',
    name: 'feedbackList',
    component: () => import('@/views/publicView/feedback/feedbackList.vue'),
    meta: {
      title: '反馈列表'
    }
  },
  {
    path: '/publicView/device/virtualSnLicenseList',
    name: 'publicView/device/virtualSnLicenseList',
    component: () => import('@/views/publicView/device/virtualSnLicenseList.vue'),
    meta: {
      title: '授权许可'
    }
  },
  {
    path: '/publicView/device/virtualSnBatchList',
    name: 'publicView/device/virtualSnBatchList',
    component: () => import('@/views/publicView/device/virtualSnBatchList.vue'),
    meta: {
      title: '授权批次'
    }
  },{
    path: '/publicView/model/checkModel',
    name: 'publicView/model/checkModel',
    component: () => import('@/views/publicView/model/checkModel.vue'),
    meta: {
      title: '查看'
    }
  },{
    path: '/publicView/upload/uploadAndEncryption',
    name: 'publicView/upload/uploadAndEncryption',
    component: () => import('@/views/publicView/upload/uploadAndEncryption.vue'),
    meta: {
      title: '上传证书'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/publicRouter.js